import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const trashPlansRoute: InvariantJiraRoute = {
	name: 'trash-plans-directory',
	path: '/jira/plans/settings/trash',
	exact: true,
};
